import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { ContentForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { content, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Contents", link: "/content" },
                { name: "Edit", link: "" },
                { name: content?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Content" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Content Update"}
                        bordered={true}
                    >
                        {content && (
                            <ContentForm
                                content={content}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
